import { useNavigate } from 'react-router-dom'
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import { toLocaleCurrency } from 'utils/dinero'

const styles = {
  box: 'flex justify-between items-center py-2',
  key: 'text-xs font-medium',
  title:
    'flex justify-between items-center text-blue-900 text-xs font-bold py-2',
  value: 'text-xs font-bold flex gap-2 items-center',
  newValue: 'flex items-center text-[#A8A8A8] text-xs line-through'
}

const formatPercentage = (value) => `${(Number(value) * 100).toFixed()}%`

const DetailModal = ({ info, isOpen, setIsOpen }) => {
  const {
    delivered_amount: deliveredAmount,
    publish_date: publishDate,
    installments_count: installmentsCount,
    installment_amount: installmentAmount,
    interest_rate: interestRate,
    tfc,
    repayable_amount: repayableAmount
  } = info

  const LIST = [
    {
      title: 'Fecha de otorgación',
      value: new Date(publishDate).toLocaleDateString('es-AR')
    },
    {
      title: 'Cuotas',
      value: `${installmentsCount} de $${toLocaleCurrency(installmentAmount)}`
    },
    {
      title: 'Tasa Nominal Anual(TNA)',
      value: formatPercentage(interestRate)
    },
    {
      title: 'Costo Financiero Total (CFT)',
      value: formatPercentage(tfc)
    },
    {
      title: 'Total a devolver',
      value: `$${toLocaleCurrency(repayableAmount)}`
    }
  ]

  const navigate = useNavigate()

  return (
    <ModalContainer
      title={`${info.type === 'cash-advance' ? 'Adelanto' : 'Préstamo'} #${
        info.id
      }`}
      isShown={isOpen}
      setModalFunction={setIsOpen}
      noCloseButton
    >
      <dl className='divide-y divide-gray-500 w-full pb-2'>
        <div className={styles.title}>
          <dt>Monto solicitado</dt>
          <dd>${toLocaleCurrency(deliveredAmount)}</dd>
        </div>
        {LIST.map((i, idx) => (
          <div key={idx} className={styles.box}>
            <dt className={styles.key}>{i.title}</dt>
            <dd className={styles.value}>{i.value}</dd>
          </div>
        ))}
      </dl>
      <PrimaryButton
        buttonText='Cerrar'
        primaryButtonFunction={() => setIsOpen(false)}
      />
      <PrimaryButton
        className='mt-4'
        outlined
        buttonText='Necesito ayuda'
        primaryButtonFunction={() => navigate('/centro-de-ayuda')}
      />
    </ModalContainer>
  )
}

export default DetailModal
